import React, { memo, useEffect, useState } from 'react';

import { useDBSyncContext } from '@/context/DBSyncContext';
import { useOrganisationsContext } from '@/context/OrganisationsContext';
import { useOrgUserContext } from '@/context/OrgUserContext';
import { getRoleAllowedRoutes } from '@/helpers/router';
import { ROUTE, routes } from '@/router/routes';

import { SidebarLinksListItem } from './components';
import { Props } from './types';

const Separator = () => (
    <div
        style={{
            height: '1px',
            backgroundColor: '#70707050',
            margin: '12px 0',
        }}
    />
);

function SidebarLinksList({ currentPathname, links }: Props) {
    const { isInitialSyncInProgress } = useDBSyncContext();
    const { orgUser } = useOrgUserContext();
    const { userOrganisations } = useOrganisationsContext();
    const [roleAllowedRoutes, setRoleAllowedRoutes] = useState<ROUTE[] | null>(
        null,
    );

    useEffect(() => {
        if (!isInitialSyncInProgress && orgUser) {
            setRoleAllowedRoutes(
                getRoleAllowedRoutes(
                    routes,
                    orgUser.role,
                    userOrganisations?.some((org) => org.owner) ?? false,
                ),
            );
        }
    }, [isInitialSyncInProgress, orgUser, orgUser?.role, userOrganisations]);

    return (
        <>
            {links
                .filter(
                    (link) =>
                        roleAllowedRoutes &&
                        roleAllowedRoutes.includes(link.path as ROUTE),
                )
                .map((link) => (
                    <React.Fragment key={link.id}>
                        {link.withSeparator && <Separator />}
                        <SidebarLinksListItem
                            isActive={currentPathname.includes(link.path)}
                            linkData={link}
                        />
                    </React.Fragment>
                ))}
        </>
    );
}

export default memo(SidebarLinksList);
